export function hasKey<O>(obj: O, key: string | number | symbol | null): key is keyof O {
    return !!(key !== null && obj && typeof obj === 'object' && key in obj);
}
